// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

import { ExamInformation } from '../../types/Model';

export interface ExamInformationRequestPayload {
  id: number;
  condition: string;
  workshopId?: number;
  iltCourseId?: number;
  preventLoading?: boolean;
}
export interface ExamInformationSuccessPayload {
  examInformation: ExamInformation;
}

export interface ExamInformationFailPayload {
  error: Error;
}

export const getExamInformationActions = createAsyncAction(
  'elearning/GET_EXAM_INFORMATION',
  'elearning/GET_EXAM_INFORMATION_SUCCESS',
  'elearning/GET_EXAM_INFORMATION_FAIL'
)<ExamInformationRequestPayload, ExamInformationSuccessPayload, ExamInformationFailPayload>();
